import { NotificationManager } from "../../components/common/react-notifications";
import { findModuleInMenu } from '../../helpers/Utils';
import _moment from "../../libs/moment"

const resolveRangePreset = (from, to) => {
  if (!from || !to || !_moment(from).isValid() || !_moment(to).isValid()) return null

  const fromDate = _moment(from)
  const toDate = _moment(to)

  if (fromDate.isSame(toDate, "day")) return 0
  if (toDate.isSame(fromDate.clone().add(+7, "days"), "day")) return 1
  if (toDate.isSame(fromDate.clone().add(+30, "days"), "day")) return 2

  return 3
}

const resolveCategoryType = (categoryId, type) => {
  if (type) return type
  if (!categoryId) return null
  if (typeof categoryId === "object") return categoryId.original?.type || categoryId.type || null
  return null
}

const isPhotoCategory = (ctx) => resolveCategoryType(ctx.state.categoryId, ctx.state.type) === "pho"

export default (context) => {
  const M = "admPublication."
  const onCreateSuccess = (r) => {
    context.setState({showFormCustom: false, btnCancel: "main.close"}, () => {
      context.getDataById(r.data)
    })
  }
  const onGetDataById = () => {
    if (context.state.btnCancel === "main.close") {
      NotificationManager.success('Successful registration', '', 5000, null, null, 'outline')
      context.setState({showFormCustom: true}, () => {
        setTimeout(() => {
          const detailGrid = document.getElementById("detailGrid")
          if (detailGrid) detailGrid.scrollIntoView({ behavior: "smooth" })
        }, 500)
      })
    }
  }
  const admPublicationPart = findModuleInMenu(context.props.menuItems, "id", "admPublicationPart")

  return {
    config: {
      pageSize: 40,
      list: false,
      enableContexMenu: true,
      remapRow: (form) => {
        return form
      }
    },

    actions: {
      create: true,
      edit: true,
      delete: true,
      print: true,
      export: true,
      search: true
    },

    filter: {
      fields: [
        {
          name: "type",
          value: "",
          type: "select",
          label: `${M}publicationType`,
          rules: 'required',
          opts: {
            style: 'float-label',
            items: [
              {value: "pub", label: `${M}postWeeklyBulletin`},
              {value: "pho", label: `${M}media`},
              {value: "", label: "main.all"}
            ]
          }
        },
        {
          name: "toDateType",
          value: 0,
          type: "select",
          label: "main.status",
          opts: {
            style: 'float-label',
            items: [
              {value: 0, label: `${M}publishedVisibleUntil`},
              {value: 1, label: `${M}unpublishedUntil`},
              {value: 2, label: "main.all"}
            ]
          }
        },
        {
          name: "toDate",
          value: null,
          type: "date",
          label: "main.date",
          opts: {
            style: 'float-label'
          }
        },
        {
          name: "superSectionId",
          value: null,
          type: "select",
          label: `${M}visibleForGrades`,
          opts: {
            style: 'float-label',
            path: "/admSuperSection/get?pick=true"
          }
        },
        {
          name: "sectionId",
          value: null,
          type: "select",
          label: `${M}visibleForClasses`,
          parent: 'superSectionId',
          opts: {
            style: 'float-label',
            path: () => `/admSection/get?pick=true&parentId=${context.state.formFilter.superSectionId || ''}`
          },
          renderIf: (ctx) => ctx.state.superSectionId
        }
      ],
      buttons: [
        {
          label: 'main.applyFilter',
          renderIf: (ctx) => { return ctx.state.toDateType || ctx.state.toDate || ctx.state.superSectionId || ctx.state.sectionId },
          onClick: (ctx) => { ctx.btnAction('filter') }
        }
      ]
    },

    form: {
      remapOne: (r) => {
        if (r.status >= 0) {
          const categoryType = resolveCategoryType(r.data.categoryId, r.data.type)
          r.data.categoryId = { value: r.data.categoryId, label: r.data.categoryName, type: categoryType }
          if (categoryType) r.data.type = categoryType
          const rangePreset = resolveRangePreset(r.data.publishFrom, r.data.publishTo)
          if (rangePreset !== null) r.data.range = rangePreset
        }
        return r
      },
      setValuesBeforePost: (v) => {
        if (typeof v.categoryId === "object") {
          v.type = resolveCategoryType(v.categoryId, v.type)
          v.categoryId = v.categoryId.value
        }
        if (v.superSections) {
          v.superSections = v.superSections.map(e => {
            e = { ID: e.value, name: e.label, selected: true }
            return e
          })
        }
        if (v.sections) {
          v.sections = v.sections.map(e => {
            e = { ID: e.value, name: e.label, selected: true }
            return e
          })
        }
        delete v.selectedField
        return v
      },
      onCreateSuccess: admPublicationPart ? onCreateSuccess : null,
      onGetDataById: admPublicationPart ? onGetDataById : null,
      fields: [
        {
          col: 12,
          name: "ID",
          value: null,
          type: "hide"
        },
        {
          col: 6,
          name: "name",
          value: "",
          type: "text",
          label: "main.title",
          rules: "required|max:150",
          opts: {
            style: 'float-label',
          }
        },
        {
          col: 6,
          name: "categoryId",
          value: "",
          type: "select",
          label: "main.category",
          rules: 'required',
          opts: {
            style: 'float-label',
            path: () => { return "/admCategory/get?type=pub,pho"},
            setOutput: v => v
          },
          onChange: (ctx) => {
            const categoryType = resolveCategoryType(ctx.state.categoryId)
            ctx.setState({ type: categoryType })
          }
        },
        {
          col: 12,
          name: "desc",
          value: "",
          type: "text",
          label: `${M}shortComment`,
          rules: "required|max:150",
          opts: {
            style: 'float-label',
          },
          renderIf: (ctx) => !isPhotoCategory(ctx)
        },
        {
          col: 4,
          colxs: 4,
          name: "img1",
          value: "",
          type: "dropzone",
          isDoc: false,
          rules: 'ext:jpeg,jpg,png',
          opts: {
            path: ()=> "/admPublication/file",
            accept: '.jpeg,.jpg,.png',
            output: true
          }
        },
        {
          col: 4,
          colxs: 4,
          name: "img2",
          value: "",
          type: "dropzone",
          isDoc: false,
          rules: 'ext:jpeg,jpg,png',
          opts: {
            path: ()=> "/admPublication/file",
            accept: '.jpeg,.jpg,.png',
            output: true
          }
        },
        {
          col: 4,
          colxs: 4,
          name: "img3",
          value: "",
          type: "dropzone",
          isDoc: false,
          rules: 'ext:jpeg,jpg,png',
          opts: {
            path: ()=> "/admPublication/file",
            accept: '.jpeg,.jpg,.png',
            output: true
          }
        },
        {
          col: 12,
          name: "body",
          value: "",
          type: "editor",
          label: `${M}longComment`,
          /*
          aiAssist: {
            action: 'write',
            requiredFields: ["name", "desc"],
            postUrl: "admPublication/AiAssist"
          },
          */
          renderIf: (ctx) => !isPhotoCategory(ctx)
        },
        {
          col: 12,
          name: "body",
          value: "",
          type: "textarea",
          label: `${M}longComment`,
          opts: {
            rows: 8,
            style: "float-label"
          },
          renderIf: (ctx) => isPhotoCategory(ctx)
        },
        {
          col: 12,
          name: "published",
          value: true,
          type: "switch",
          label: `${M}publishedVisible`,
        },
        {
          type: "daterange",
          isFormCrud: true,
          from: {
            col: 4,
            name: "publishFrom",
            value: "",
            type: "date",
            label: `${M}visibleFrom`,
            rules: "required",
            renderIf: () => true,
          },
          range: {
            col: 4,
            renderIf: (ctx) => ctx.state.published,
            label: "",
            rules: "required",
            opts: {
              skipInitialOnChange: true
            }
          },
          
          to: {
            col: 4,
            name: "publishTo",
            value: "",
            type: "date",
            label: `${M}visibleUntil`,
            rules: "required"
          }
        },
        {
          col: 6,
          name: "superSections",
          value: "",
          type: "select",
          label: `${M}visibleForGrades`,
          opts: {
            style: 'float-label',
            path: "/admSuperSection/get?pick=true",
            isMulti: true,
            setOutput: v => v
          },
          renderIf: (ctx) => ctx.state.published
        },
        {
          col: 6,
          name: "sections",
          value: "",
          type: "select",
          label: `${M}visibleForClasses`,
          parent: 'superSections',
          opts: {
            style: 'float-label',
            path: () => `/admSection/get?pick=true&parentId=${((context.state.form.superSections && context.state.form.superSections.length > 0) ? context.state.form.superSections[0].value : null)}`,
            isMulti: true,
            setOutput: v => v
          },
          renderIf: (ctx) => { return (ctx.state.published &&  ctx.state.superSections?.length === 1) || (ctx.state.published && ctx.state.sections?.length >= 1)}
        },
        {
          col: 12,
          name: "empty1",
          type: "separator",
        },
        {
          col: 12,
          name: "tab1",
          value: false,
          type: "collapsible",
          placeholder: `${M}enterSecondaryLanguage`,
          childs: [
            {
              col: 12,
              name: "nameEN",
              value: "",
              type: "text",
              label: "main.desc",
              aiAssist: {
                action: 'translate',
                requiredFields: ["name", "desc"],
                postUrl: "admPublication/AiAssist"
              },
              opts: {
                style: 'float-label',
              }
            },
            {
              col: 12,
              name: "descEN",
              value: "",
              type: "text",
              label: `${M}shortComment`,
              opts: {
                style: 'float-label',
              },
              renderIf: (ctx) => !isPhotoCategory(ctx)
            },
            {
              col: 12,
              name: "bodyEN",
              value: "",
              type: "editor",
              label: `${M}longComment`,
              renderIf: (ctx) => !isPhotoCategory(ctx)
            },
            {
              col: 12,
              name: "bodyEN",
              value: "",
              type: "textarea",
              label: `${M}longComment`,
              opts: {
                rows: 8,
                style: "float-label"
              },
              renderIf: (ctx) => isPhotoCategory(ctx)
            }
          ]
        },
        {
          col: 12,
          name: "tab2",
          value: false,
          type: "collapsible",
          placeholder: 'main.seeMoreOptions',
          childs: [
            {
              col: 12,
              name: "by",
              value: "",
              type: "text",
              label: "main.author",
              opts: {
                style: 'float-label',
              }
            },
            {
              col: 4,
              name: "pinTop",
              value: false,
              type: "switch",
              label: `${M}importantPin`,
            },
            {
              col: 12,
              name: "labelSpacer",
              value: L => `<h5>${L[`${M}whoCanSee`]}</h5>`,
              type: "label",
            },
            {
              col: 4,
              name: "accessPrincipal",
              value: true,
              type: "switch",
              label: `${M}parentsGuardians`,
            },
            {
              col: 4,
              name: "accessDependant",
              value: true,
              type: "switch",
              label: "main.students"
            },
            {
              col: 4,
              name: "accessMaster",
              value: true,
              type: "switch",
              label: `${M}staffTeachers`,
            }
          ]
        }
      ],
      detailGrid: admPublicationPart ? () => {
        return {
          module: 'admPublicationPart',
          parentIdField: "ID",
          renderIf: () => context.state.form && context.state.form.ID
        }
      } : null
    },

    columns: [
      {
        Header: "main.ID",
        accessor: "ID"
      },
      {
        Header: "main.name",
        accessor: "name"
      },
      {
        Header: `${M}publishedVisible`,
        accessor: "published",
        isBool: true
      },
      {
        Header: `${M}visibleFrom`,
        accessor: "publishFrom",
        isDate: true
      },
      {
        Header: `${M}visibleUntil`,
        accessor: "publishTo",
        isDate: true
      },
      {
        Header: `${M}importantPin`,
        accessor: "pinTop",
        isBool: true
      }
    ]
  }
}